import EntityApi from "../Api/EntityApi";

class StartListService {

    constructor(jsonApi, state) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;

        this.state.add('classes', []);
        this.state.add('ageClasses', []);
        this.state.add('modificationTime', 0);
        this.state.add('loading', true);
        this.state.add('error', '');
        this.state.add('sorting', 'bib');
        this.state.add('showNonPaid', false);
    }

    fetchClasses() {
        this.state.setLoading(true);
        this.state.setError('');
        this.entityApi.list('CompetitionClass', 'startlist',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.state.setModificationTime(data.data.modified);
                    this.updateClassses(list);
                    this.fetchAgeClasses();
                }

            },
            (res) => {
                if (res.status !== 'nochange') {
                    console.log('fetch failed:' + res.message);
                    this.state.setError(res.message);
                }
                this.state.setLoading(false);
            },
            -1); //this.state.modificationTime);
    }

    fetchAgeClasses() {
        this.state.setLoading(true);
        this.state.setError('');
        this.entityApi.list('AgeClass', 'startlist',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.updateAgeClassses(list);
                }

                this.state.setLoading(false);
            },
            (res) => {
                if (res.status !== 'nochange') {
                    console.log('fetch failed:' + res.message);
                    this.state.setError(res.message);
                }
                this.state.setLoading(false);
            },
            -1); //this.state.modificationTime);
    }

    sortRunners() {
        this.state.classes.forEach(compClass => {
            compClass.runners = compClass.runners.sort((a, b) => {
                if (this.state.sorting === 'bib')
                    return a.bib - b.bib;
                return String(a[this.state.sorting]).localeCompare(b[this.state.sorting]);
            });
        });
        return this.state.classes;
    }

    sortAgeRunners() {
        this.state.ageClasses.forEach(ageClass => {
            ageClass.runners = ageClass.runners.sort((a, b) => {
                if (this.state.sorting === 'bib')
                    return a.bib - b.bib;
                return String(a[this.state.sorting]).localeCompare(b[this.state.sorting]);
            });
        });
        return this.state.ageClasses;
    }

    updateClassses(list) {
        this.state.setClasses(list.sort((a, b) => a.order - b.order));
    }

    updateAgeClassses(list) {
        this.state.setAgeClasses(list.sort((a, b) => a.order - b.order));
    }
}

export default StartListService;